import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('InvBuyerSubEntityRelationFilter', InvBuyerSubEntityRelationFilterData);

    function InvBuyerSubEntityRelationFilterData() {
        InvBuyerSubEntityRelationFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
        };

        function InvBuyerSubEntityRelationFilter(invBuyerSubEntityRelationFilterData) {
            if (!invBuyerSubEntityRelationFilterData) {
                this.buildEmpty();
            } else {
                this.build(invBuyerSubEntityRelationFilterData);
            }
        }

        return InvBuyerSubEntityRelationFilter;

        function buildEmpty() {
            this.subEntity = null;
            this.legalEntity = null;
            this.country = null;
            this.invitedEntityStatus = null;
            this.subEntityStatus = null;
            this.onlyAccepted = null;
        }

        function build(invBuyerSubEntityRelationFilter) {
            this.subEntity = invBuyerSubEntityRelationFilter.subEntity || null;
            this.legalEntity = invBuyerSubEntityRelationFilter.legalEntity || null;
            this.country = invBuyerSubEntityRelationFilter.country || null;
            this.invitedEntityStatus = invBuyerSubEntityRelationFilter.invitedEntityStatus || null;
            this.subEntityStatus = invBuyerSubEntityRelationFilter.subEntityStatus || null;
            this.onlyAccepted = invBuyerSubEntityRelationFilter.onlyAccepted || null;
        }

        function preparBeforeSearch() {
            var clone = new InvBuyerSubEntityRelationFilter(this);
            clone.subEntity = this.subEntity || null;
            clone.legalEntity = this.legalEntity || null;
            clone.country = this.country || null;
            clone.invitedEntityStatus = this.invitedEntityStatus || null;
            clone.subEntityStatus = this.subEntityStatus || null;
            clone.onlyAccepted = this.onlyAccepted || null;
            return clone;
        }
    }
})();
